import { makeStyles } from '@mui/styles'

const styles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  dialogCloseButton: {
    position: 'absolute',
    right: '1.3rem',
    top: '1.3rem',
    color: theme.palette.primary,
  },

}))

export default styles
